// Dati del venditore — centralizzati per facile aggiornamento futuro.
// NB: venditore persona fisica senza partita IVA. Non aggiungere P.IVA/REA/CF/indirizzo privato
// senza autorizzazione esplicita.
export const LEGAL_VERSION = "2026-08-26";

export const COMPANY = {
  seller: "Pierluigi Mancuso",
  brand: "LearnSphereHub",
  status: {
    it: "Persona fisica (venditore senza partita IVA)",
    en: "Natural person (seller without VAT number)",
  },
  // Email pubblica e di assistenza (IONOS) — centralizzata per facile aggiornamento futuro.
  supportEmail: "assistenza@learnspherehub.it",
  site: "https://learnspherehub.it",
};
